import i18next, { TFunction } from 'i18next';

/*
 * Translate function
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
export const t: TFunction = (...args: any[]) => i18next.t(...args);
